/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Essential_CookiesInputs */

const en_essential_cookies = /** @type {(inputs: Essential_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essential`)
};

const es_essential_cookies = /** @type {(inputs: Essential_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esenciales`)
};

const fr_essential_cookies = /** @type {(inputs: Essential_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essentiels`)
};

/**
* | output |
* | --- |
* | "Essential" |
*
* @param {Essential_CookiesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const essential_cookies = /** @type {((inputs?: Essential_CookiesInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Essential_CookiesInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_essential_cookies(inputs)
	if (locale === "es") return es_essential_cookies(inputs)
	return fr_essential_cookies(inputs)
});